<template>
  <div class="d-flex relative">
    <AppSearchInput
      class="template-search"
      search-placeholder="Wyszukaj szablonu"
      @search="filterElements({ query: $event })"
    />

    <v-select
      :value="selectedFilters.projectType"
      :items="filtersOptions.projectTypes"
      placeholder="Typ projektu"
      v-bind="props.select"
      class="width-140"
      @input="selectToggleFilter({ projectType: $event })"
    />

    <v-btn
      v-if="filtersActive"
      text
      class="primary--text clear-filters-button ml-2"
      @click="clearAllFilters"
    >
      Wyczyść filtry
    </v-btn>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import props from '@/helpers/componentsProps';
import utils from '@/helpers/utils';
import AppSearchInput from '@/components/UI/AppSearchInput.vue';

export default {
  components: {
    AppSearchInput,
  },

  props: {
    archive: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      props,
    };
  },

  computed: {
    ...mapState('filters', ['filtersOptions', 'selectedFilters']),

    filtersActive() {
      return utils.areFiltersSet(this.selectedFilters, this.archive);
    },
  },

  methods: {
    ...mapActions('filters', ['setFilters', 'clearFilters']),

    selectToggleFilter(filterObject) {
      utils.checkIfFilterExists(filterObject, this.selectedFilters, this.filterElements);
    },

    filterElements(filterObject) {
      this.setFilters(filterObject).then(() => {
        this.$emit('search');
      });
    },

    clearAllFilters() {
      const params = this.archive ? { statuses: ['Zaakceptowany i zarchiwizowany'] } : null;
      this.clearFilters(params).then(() => {
        this.$emit('search');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.template-search {
  margin-right: 8px;
  width: 172px;
  @include desktop {
    width: 326px;
  }
}
</style>
